<div class="container-sm">
  <div class="row">
    @for (item of data.teasers; track $index) {
      <div class="col-12 col-md-6 cardWrapper">
        <mb-card
          (click)="openCardMedia(item)"
          [data]="item"
          [layouts]="layouts"
          [actions]="item.actions"
          alignContent="top"
        >
          <figure>
            <mb-media [media]="item.media" [hoverplay]="true"></mb-media>
          </figure>
        </mb-card>
      </div>
    }
  </div>
</div>
